var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailPink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.909,
    height: 19.127,
    viewBox: "0 0 23.909 19.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-email",
    "data-name": "Icon material-email",
    d: "M24.519,6H5.391A2.388,2.388,0,0,0,3.012,8.391L3,22.737a2.4,2.4,0,0,0,2.391,2.391H24.519a2.4,2.4,0,0,0,2.391-2.391V8.391A2.4,2.4,0,0,0,24.519,6Zm0,4.782-9.564,5.977L5.391,10.782V8.391l9.564,5.977,9.564-5.977Z",
    transform: "translate(-3 -6)",
    fill: "#eb7c7c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPink);
export default __webpack_public_path__ + "static/media/email_pink.600a2417c80aa8b908c2ecece78f56da.svg";
export { ForwardRef as ReactComponent };